module.exports = __webpack_public_path__ + "static/media/ESFP.bd362bae.png";